module.exports = __webpack_public_path__ + "static/img/WILL-GREEN.082fbc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WILL-GREEN.jpg
// module id = 6afG
// module chunks = 0